import * as React from "react";
import { render } from "react-dom";
import { App } from "./app";

export const boot = () => {
	const app = document.getElementById("app");
	app.style.height = "100vh";

	render(App, document.getElementById("app"));
};

boot();
